import { Trans } from "@lingui/macro";

import { MenuIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const TabBarMoreItem = () => {
  return (
    <Box
      borderRadius="6"
      pb={3}
      pt={4}
      px={5}
      alignItems="center"
      justifyContent="flex-start"
      minWidth={64}
      height={64}
      width={"auto"}
    >
      <VStack
        alignItems="center"
        justifyContent="center"
        gap={1}
        flexDirection={{ base: "column", lg: "row" }}
      >
        <MenuIcon color="black" />

        <Text
          marginLeft={{ base: 0, lg: 2 }}
          color="grayscale-1000"
          variant="mainTiny"
          mb={0}
        >
          <Trans>More</Trans>
        </Text>
      </VStack>
    </Box>
  );
};
